import { MentionNodeDataProvider } from '@atlaskit/editor-plugin-mentions/mention-node-data-provider';

import { expVal, expValEquals } from '@confluence/feature-experiments';
import { getCloudId } from '@confluence/session-data/entry-points/SessionData.ts';
import { getRovoChatIdentityFromCache } from '@confluence/fabric-media-support/entry-points/preloadRovoChatIdentity.ts';

type MentionAvatarData = {
	avatarUrl: string;
	isAvatarImagePreShaped: boolean;
	isRovoChat?: boolean;
};

type MentionNodeIdentifier = {
	id: string;
	userType?: string;
};

const resolveMentionNodeData = ({
	id: accountId,
	userType,
}: MentionNodeIdentifier): MentionAvatarData => {
	const avatarData = {
		avatarUrl: `/wiki/aa-avatar/${encodeURIComponent(accountId)}`,
		isAvatarImagePreShaped:
			userType !== 'APP' && userType !== 'AGENT'
				? true
				: !expVal('platform_editor_drop3_hexagon_agent_avatar', 'isEnabled', false),
	};
	if (expValEquals('platform_editor_mention_rovo', 'isEnabled', true)) {
		const cloudId = getCloudId();
		return {
			...avatarData,
			isRovoChat: !!cloudId && getRovoChatIdentityFromCache(cloudId) === accountId,
		};
	}
	return avatarData;
};

/** Creates a page-scoped provider backed by Confluence's deterministic avatar route. */
export const createMentionNodeDataProvider = (): MentionNodeDataProvider =>
	new MentionNodeDataProvider(() => Promise.resolve({}), resolveMentionNodeData);
